import { paySmallSmallActions } from '@/store/pay-small-small-reducer'
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore'
import AuthRepository from '../repositories/auth-repository'
import { RootState } from '../store'
import { AuthActions } from '../store/auth-reducer'
import { devicesStateActions } from '@/store/devices-reducer'
import { transactionsActions } from '@/store/transactions-reducer'
import { serviceRequestPageActions } from '@/store/service-requests-reducer'
import { walletsActions } from '@/store/wallets-reducer'
import { signIn, signOut } from 'next-auth/react'

export default class AuthService {
    constructor(
        private authRepository: AuthRepository,
        private store: ToolkitStore<RootState>,
        private authActions: AuthActions,
    ) {}

    async sendOTP(phoneNumber: string, reCapturetoken: string) {
        const payload = {
            phoneNumber: phoneNumber,
            reCapturetoken,
            countryCode: 'GH',
        }
        const res = await this.authRepository.sendOTP(payload)
        this.store.dispatch(
            this.authActions.setLoginData({
                ...res.data.data,
                ...payload,
            }),
        )
        return Promise.resolve(res.data)
    }

    verifyOTP(otpCode: string) {
        const loginData = this.store.getState().auth.loginData

        return signIn('otp-verification', {
            code: otpCode,
            prefix: loginData.prefix,
            requestId: loginData.requestId,
            redirect: false,
        })
    }

    async resendOTP() {
        try {
            const loginData = this.store.getState().auth.loginData
            const res = await this.authRepository.sendOTP({
                phoneNumber: loginData.phoneNumber,
                countryCode: loginData.countryCode,
            })

            this.store.dispatch(
                this.authActions.setLoginData({
                    ...loginData,
                    ...res.data.data,
                }),
            )
            return res
        } catch (error) {}
    }

    isAuthTokenValid(accessToken: string) {
        // make an API call to validate cookie
        if (accessToken.length > 40) {
            // this.authRepository.verifyToken(accessToken)
            return true
        }

        return false
    }

    logoutUser() {
        this.store.dispatch(this.authActions.resetState())
        this.store.dispatch(paySmallSmallActions.resetState())
        this.store.dispatch(devicesStateActions.resetState())
        this.store.dispatch(transactionsActions.resetState())
        this.store.dispatch(serviceRequestPageActions.resetState())
        this.store.dispatch(walletsActions.resetState())

        this.authRepository.client.clearCache()

        localStorage.clear()
        signOut({ callbackUrl: '/login' })
    }

    async getUserpofile() {
        const res = await this.authRepository.getUserprofile()
        this.store.dispatch(this.authActions.setUserProfile(res.data))
        return res
    }

    updateUserEmail(email: string) {
        return this.authRepository.updateUserEmail(email)
    }

    postpaidBillQrCodeAuth(phoneNumber: string) {
        return this.authRepository.postpaidBillQrCodeAuth(phoneNumber)
    }
}
